import {
    Box,
    Divider,
    FormControl,
    FormControlLabel,
    FormLabel,
    Grid,
    Radio,
    RadioGroup,
    Stack,
    Typography,
} from '@mui/material';

import { InputBaseField } from 'src/components/common/form/FormInput';
import MainCard from 'src/components/MainCard/MainCard';
import { useAddMerchantContext } from 'src/contexts/AddMerchantProvider';
import { isApplicationEditable } from 'src/pages/MerchantApplicationPage/merchantApplicationHelpers.util';

export const BusinessInformationForm = ({ values, setFieldValue }) => {
    const { merchantApplication } = useAddMerchantContext();
    const isEditingDisabled = isApplicationEditable(merchantApplication);

    return (
        <MainCard>
            <Typography fontSize="24px" color="#575757" marginBottom="8px">
                Business Information
            </Typography>
            <Divider
                sx={{
                    borderColor: 'warning.main',
                    marginBottom: '34px',
                }}
            />
            <Box display="flex" gap="24px" flexDirection="column">
                <Grid container spacing={2} display="flex" alignItems="flex-end">
                    {/* NOTE: temporarily hide the ta code and member of TA name */}
                    {/* <Grid item xs={12} lg={6}>
            <InputBaseField
              name="taCode"
              label="TA Code"
              placeholder="Enter TA Code"
              disabled
            />
          </Grid>
          */}
                    <Grid item xs={12} lg={6}>
                        <InputBaseField
                            name="memberTaName"
                            label="Member of/TA Name"
                            placeholder="Enter Member of/TA Name"
                            disabled={isEditingDisabled}
                        />
                    </Grid>
                    {/* Merchant number & radio buttons */}
                    <Grid item xs={6}>
                        <Stack direction="row" spacing={2} alignItems="center">
                            <FormLabel id="existingAcquirerRelationship" sx={{ color: '#575757' }}>
                                Existing Acquirer Relationship
                            </FormLabel>
                            <FormControl>
                                <RadioGroup
                                    aria-labelledby="existingAcquirerRelationship"
                                    value={values.existingAcquirerRelationship}
                                    name="existingAcquirerRelationship"
                                    row
                                    onChange={(event) => {
                                        setFieldValue(
                                            'existingAcquirerRelationship',
                                            JSON.parse(event.target.value)
                                        );
                                    }}
                                >
                                    <FormControlLabel
                                        value={true}
                                        control={<Radio />}
                                        label="Yes"
                                        disabled={isEditingDisabled}
                                    />
                                    <FormControlLabel
                                        value={false}
                                        control={<Radio />}
                                        label="No"
                                        disabled={isEditingDisabled}
                                    />
                                </RadioGroup>
                            </FormControl>
                        </Stack>
                        {values.existingAcquirerRelationship && (
                            <InputBaseField
                                name="merchantNumber"
                                label="Merchant Number"
                                placeholder="Enter Merchant Number"
                                disabled={isEditingDisabled}
                            />
                        )}
                    </Grid>

                    {/* Membership numbers */}
                    <Grid item xs={6}>
                        <InputBaseField
                            name="membershipNumber"
                            label="Membership Number"
                            placeholder="Enter Membership Number"
                            disabled={isEditingDisabled}
                        />
                    </Grid>
                </Grid>
            </Box>
        </MainCard>
    );
};
